import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddPopulationMutation, useDeletePopulationMutation, useEditPopulationMutation } from "../../../redux/api/population/populationApi";
import { EntPopulation } from "../../../models/population";
import { getCookie } from "typescript-cookie";


const usePopulation = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addPopulation] = useAddPopulationMutation();
    const [deletePopulation] = useDeletePopulationMutation();
    const [editPopulation] = useEditPopulationMutation();


    async function onAddPopulation(newPopulation: EntPopulation): Promise<boolean> {
        try {
            let status: boolean = false;
            await addPopulation(newPopulation).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeletePopulation(role: EntPopulation) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deletePopulation(role.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditPopulation(editedPopulation: EntPopulation): Promise<boolean> {
        try {
            let status: boolean = false;
            await editPopulation(editedPopulation).then((response: any) => {
                  if (response.error) {
                                              const isKyrgyz = getCookie('i18next') === 'ky';
                                              const lang = isKyrgyz ? 'kg' : 'ru';
                                              const res = response.error.data?.res;
                                              const errorMessages = Array.isArray(res)
                                                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                  : response.error.data?.msg || t('unknownError'); 
                                              throw new Error(errorMessages);
                                          }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddPopulation,onDeletePopulation, onEditPopulation }

}
export { usePopulation };

